import { render, staticRenderFns } from "./ApartmentAccessPermission.vue?vue&type=template&id=6a371f8a"
import script from "./ApartmentAccessPermission.vue?vue&type=script&lang=js"
export * from "./ApartmentAccessPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports